import { render } from "./admissionView.vue?vue&type=template&id=023bfc57"
import script from "./admissionView.vue?vue&type=script&lang=js"
export * from "./admissionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__